import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { TextField, Button, MenuItem, Box, AppBar, Toolbar, Typography } from '@mui/material';
import axios from 'axios';
import { CONFIG } from '../config';

function Register() {
  const [username, setUsername] = useState('');
  const [birthday, setBirthday] = useState('');
  const [kind, setKind] = useState('');
  const [institution, setInstitution] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const kinds = [
    { value: 'Profesional de la Salud', label: 'Profesional de la Salud' },
    { value: 'Estudiante', label: 'Estudiante' },
    { value: 'Investigador', label: 'Investigador' },
  ];

  const registerUser = async () => {
    const payload = {
      email,
      username,
      birthday,
      kind,
      institution,
      password,
    };

    const response = await axios.post(
      CONFIG.BACKEND_URL + '/backend/registeruser',
      payload
    );

    if (response.data?.code === 200) {
      navigate('/politica-privacidad', { state: { email } });
    }
  };

  const handleChange = (e) => {
    const { id, name, value } = e.target;
    setErrors((prev) => ({ ...prev, [id || name]: false }));

    const setter = {
      username: setUsername,
      birthday: setBirthday,
      kind: setKind,
      institution: setInstitution,
      mail: setEmail,
      email: setEmail,
      password: setPassword,
      confirmPassword: setConfirmPassword,
    };
    const key = id || name;
    if (setter[key]) setter[key](value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};

    if (!username.trim()) newErrors.username = true;
    if (!birthday.trim()) newErrors.birthday = true;
    if (!kind.trim()) newErrors.kind = true;
    if (!institution.trim()) newErrors.institution = true;
    if (!email.trim()) newErrors.mail = true;
    if (!password.trim()) newErrors.password = true;
    if (password !== confirmPassword) newErrors.confirmPassword = true;
    if (!confirmPassword.trim()) newErrors.confirmPassword = true;

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setIsLoading(true);
    try {
      await registerUser();
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'No se pudo conectar al servidor.';
      alert('Error en el registro: ' + msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid animation-container">
      <div className="row d-flex justify-content-center align-items-center h-100">
        <div className="col d-flex column-container">
          <div className="m-auto text-container">
            <h2 className="title">BANAS</h2>
          </div>
        </div>
        <div className="col colForm">
          <h2 className="mb-4">Registro</h2>
          <form className="form-container" onSubmit={handleSubmit}>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                id="username"
                label="Nombre"
                value={username}
                onChange={handleChange}
                error={!!errors.username}
                required
                className="custom-textfield"
              />
              {errors.username && (
                <div className="invalid-feedback">Este campo es requerido</div>
              )}
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                id="birthday"
                label="Fecha de nacimiento"
                type="date"
                value={birthday}
                onChange={handleChange}
                error={!!errors.birthday}
                required
                InputLabelProps={{ shrink: true }}
                className="custom-textfield"
              />
              {errors.birthday && (
                <div className="invalid-feedback">Este campo es requerido</div>
              )}
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                id="kind"
                name="kind"
                label="Tipo"
                select
                value={kind}
                onChange={handleChange}
                error={!!errors.kind}
                required
                className="custom-textfield"
              >
                {kinds.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              {errors.kind && (
                <div className="invalid-feedback">Este campo es requerido</div>
              )}
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                id="institution"
                label="Institución"
                value={institution}
                onChange={handleChange}
                error={!!errors.institution}
                required
                className="custom-textfield"
              />
              {errors.institution && (
                <div className="invalid-feedback">Este campo es requerido</div>
              )}
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                id="mail"
                label="Correo electrónico"
                type="email"
                value={email}
                onChange={handleChange}
                error={!!errors.mail}
                required
                className="custom-textfield"
              />
              {errors.mail && (
                <div className="invalid-feedback">Este campo es requerido</div>
              )}
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                id="password"
                label="Contraseña"
                type="password"
                value={password}
                onChange={handleChange}
                error={!!errors.password}
                required
                className="custom-textfield"
              />
              {errors.password && (
                <div className="invalid-feedback">Este campo es requerido</div>
              )}
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                id="confirmPassword"
                label="Confirmar contraseña"
                type="password"
                value={confirmPassword}
                onChange={handleChange}
                error={!!errors.confirmPassword}
                required
                helperText={
                  errors.confirmPassword
                    ? 'Las contraseñas no coinciden'
                    : ''
                }
                className="custom-textfield"
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isLoading}
              >
                {isLoading ? 'Cargando...' : 'Registrarme'}
              </Button>
              <Button
                type="button"
                variant="contained"
                disabled={isLoading}
                onClick={() => navigate('/landing')}
                sx={{
                  bgcolor: 'grey.500',
                  '&:hover': { bgcolor: 'grey.600' },
                }}
              >
                Cancelar
              </Button>
            </Box>
          </form>
          <p className="mt-3">
            ¿Ya tienes una cuenta? <Link to="/login">Inicia sesión aquí</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;
